import Vue from 'vue';
import {
  SET_VIEW_MODE,
} from './mutations.type';

export default {
  [SET_VIEW_MODE](state, { id, viewMode }) {
    Vue.set(state.views, id, viewMode);
  },
};
